import React from "react";

const STATUS_STYLE = {
    New: "border border-charcoal/40 text-charcoal",
    Reviewing: "border border-charcoal/40 text-charcoal",
    Feasible: "bg-charcoal/10 text-charcoal",
    Contacted: "bg-charcoal/10 text-charcoal",
    Consultation: "bg-charcoal/10 text-charcoal",
    "Design Started": "border border-terracotta text-terracotta",
    "Design Completed": "border border-terracotta text-terracotta",
    Quotation: "border border-terracotta text-terracotta",
    Won: "bg-terracotta text-offwhite",
    Lost: "text-charcoal/40 border border-charcoal/20",
};

const SOURCE_STYLE = {
    Website: "border border-charcoal/40 text-charcoal",
    Meta: "bg-terracotta text-offwhite",
    Manual: "bg-charcoal text-offwhite",
};

export function StatusPill({ value }) {
    if (!value) return null;
    return (
        <span
            className={"inline-block text-[11px] font-manrope font-semibold uppercase tracking-wider px-2 py-0.5 rounded " + (STATUS_STYLE[value] || "border border-charcoal/40 text-charcoal")}
            data-testid={`status-pill-${value.toLowerCase().replace(/\s+/g,'-')}`}
        >{value}</span>
    );
}

export function SourcePill({ value }) {
    if (!value) return null;
    return (
        <span className={"inline-block text-[11px] font-manrope font-semibold uppercase tracking-wider px-2 py-0.5 rounded " + (SOURCE_STYLE[value] || "border border-charcoal/40 text-charcoal")}>
            {value}
        </span>
    );
}

export function EventStatusPill({ value }) {
    const styles = {
        processed: "border border-charcoal/40 text-charcoal",
        duplicate: "text-charcoal/50 border border-charcoal/20",
        pending: "border border-terracotta text-terracotta",
        failed: "bg-terracotta text-offwhite",
        failed_permanent: "bg-red-600 text-white",
    };
    return (
        <span className={"inline-block text-[11px] font-manrope font-semibold uppercase tracking-wider px-2 py-0.5 rounded " + (styles[value] || "")}>
            {value}
        </span>
    );
}
